import { filterConstants } from "../../../../../constants";
import {
  useGetPageQueryParams,
  useMerchantApiQueryWithParams,
  useQueryString,
} from "../../../../../hooks";
import {
  IQueryStringNavLinks,
  ITableHeader,
  IViewInvoice,
  IPageAndSearchRequest,
  PagedMeta,
  IInvoicesFilter,
} from "../../../../../interfaces-and-types";
import {
  QuickTable,
  QuickTableFilterTabs,
  SwitchAppButton,
} from "../../../../../components";
import { customerInvoicesDisplayFormatter } from "./customerInvoicesDisplayFormatter";

import { FC, ReactNode } from "react";
import { IDestinationTxOrInvoice } from "../RedirectToInvoiceForm";

interface IInvoiceQueryMeta {
  status: string;
  filter: IInvoicesFilter;
  start_date: string | null;
  end_date: string | null;
}

export interface IInvoiceViewProps {
  data: IViewInvoice[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  refreshTable: () => void;
  openDetailsModal?: (data: any) => void;
  openCreateNewModal: () => void;

  // extra buttons
  onExport: () => void;
}

export const CustomerInvoices: FC<{
  filter?: IInvoicesFilter;
  actions?: (invoice: IViewInvoice) => ReactNode;
}> = ({ filter, actions }) => {
  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);
  const { page, page_size, search } = useGetPageQueryParams();

  const startDate = query.get(filterConstants.startDateKey);
  const endDate = query.get(filterConstants.endDateKey);

  const {
    isLoading: isLoadingInvoices,
    isError: isErrorInvoices,
    // isSuccess: isSuccessInvoices,
    data: invoices,
    meta: invoicesMeta,
    // refetch: refetchInvoices,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & IInvoiceQueryMeta,
    IViewInvoice[],
    PagedMeta
  >([
    "getInvoices",
    {
      page: (page && Number(page)) || 1,
      page_size: (page_size && Number(page_size)) || 10,
      search,
      filter: {
        ...filter,
        // include_child_parital_payments:
        //   status === transactionStatus.partial ? true : false,
      },
      status: status || "active",
      start_date: startDate,
      end_date: endDate,
    },
  ]);

  const headers: ITableHeader[] = [
    {
      key: "link_url",
      header: "Link Url",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "description",
      header: "Description",
    },
    {
      key: "reference",
      header: "Reference",
    },
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "date",
      header: "Date Created",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "Available",
        value: "active",
      },
      {
        key: "Archived",
        value: "deactivated",
      },
    ],
  };

  // insert the functions to open edit/delete modals
  const invoicesWithActions: IViewInvoice[] =
    invoices?.map((invoice) => ({
      ...invoice,

      // add actions
      actions: actions && actions(invoice),
    })) || [];

  return (
    <QuickTable
      id="customerInvoicesTable"
      data={invoicesWithActions}
      headers={headers}
      isLoading={isLoadingInvoices}
      isError={isErrorInvoices}
      itemCount={invoicesMeta?.page_meta.item_count || 0}
      renderDetail={(item) => item.link_url_with_hostname}
      toolbarTabs={
        <QuickTableFilterTabs queryStringTabNavLinks={queryStringTabs} />
      }
      displayFormatter={customerInvoicesDisplayFormatter}
      disableClickOnColumns={["link_url, more"]}
    />
  );
};
